const BASE_PATH = '/static/api'

export default ajax => ({
  getList: () => ajax({
    url: `${BASE_PATH}/checkItemCategories.json`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/CheckItemCategory.js